import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SubmitUrlComponent } from "./pages/submit-url/submit-url.component";
import { IframeIntegrationComponent } from "./pages/iframe-integration/iframe-integration.component";
import { BankingCaseComponent } from "./pages/banking-case/banking-case.component";
import { RestoreJourneyComponent } from "./pages/restore-journey/restore-journey.component";

const routes: Routes = [
  { path: "", component: SubmitUrlComponent },
  { path: "iframe", component: IframeIntegrationComponent },
  { path: "banking-case", component: BankingCaseComponent },
  {
    path: "restore-journey",
    component: RestoreJourneyComponent,
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
